import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */

export class TrackingEventAdComplaintMapper extends Mapper {
  constructor({config}) {
    super()

    this._config = config
    this._TRACKING_EVENT_NAMES = this._config.get('tracking').TRACKING_EVENT_NAMES
  }

  setParams({ad, complaintReason, errorType}) {
    this._ad = ad
    this._complaintReason = complaintReason
    this._errorType = errorType
    return this
  }

  mapProducts() {
    return [
      {
        category: 'ads',
        id: this._ad.id,
        price: 0,
        quantity: 0
      }
    ]
  }

  mapReportAdViewed() {
    const data = {
      channel: 'ads',
      page_category_level1: 'denunciar anuncio',
      page_type: 'form',
      products: this.mapProducts()
    }

    if (this._complaintReason) {
      data.hit_information = this._complaintReason
      data.page_name = 'formulario denuncia'
    } else {
      data.page_name = 'motivo de denuncia'
    }

    return {
      event: this._TRACKING_EVENT_NAMES.REPORT_AD_VIEWED,
      data
    }
  }

  mapAdReported() {
    const data = {
      hit_information: this._complaintReason,
      products: this.mapProducts()
    }

    return {
      event: this._TRACKING_EVENT_NAMES.AD_REPORTED,
      data
    }
  }

  mapAdReportedError() {
    const data = {
      hit_information: this._complaintReason,
      products: this.mapProducts(),
      page_error: this._errorType
    }

    return {
      event: this._TRACKING_EVENT_NAMES.AD_REPORTED_ERROR,
      data
    }
  }

  map(eventName) {
    const mappers = {
      [this._TRACKING_EVENT_NAMES.AD_REPORTED]: 'mapAdReported',
      [this._TRACKING_EVENT_NAMES.AD_REPORTED_ERROR]: 'mapAdReportedError',
      [this._TRACKING_EVENT_NAMES.REPORT_AD_VIEWED]: 'mapReportAdViewed'
    }

    return this[mappers[eventName]]()
  }
}
